"use strict";

import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _get from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _assertThisInitialized from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { checkResultErrors, Indexed, Interface } from "@ethersproject/abi";
import { Provider } from "@ethersproject/abstract-provider";
import { Signer, VoidSigner } from "@ethersproject/abstract-signer";
import { getAddress, getContractAddress as _getContractAddress } from "@ethersproject/address";
import { BigNumber } from "@ethersproject/bignumber";
import { arrayify, concat, hexlify, isBytes, isHexString } from "@ethersproject/bytes";
import { defineReadOnly, deepCopy, getStatic, resolveProperties, shallowCopy } from "@ethersproject/properties";
import { accessListify } from "@ethersproject/transactions";
import { Logger } from "@ethersproject/logger";
import { version } from "./_version";
var logger = new Logger(version);
;
;
///////////////////////////////
var allowedTransactionKeys = {
  chainId: true,
  data: true,
  from: true,
  gasLimit: true,
  gasPrice: true,
  nonce: true,
  to: true,
  value: true,
  type: true,
  accessList: true,
  maxFeePerGas: true,
  maxPriorityFeePerGas: true,
  customData: true,
  ccipReadEnabled: true
};
function resolveName(resolver, nameOrPromise) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var name, address;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return nameOrPromise;
        case 2:
          name = _context.sent;
          if (typeof name !== "string") {
            logger.throwArgumentError("invalid address or ENS name", "name", name);
          }
          // If it is already an address, just use it (after adding checksum)
          _context.prev = 4;
          return _context.abrupt("return", getAddress(name));
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](4);
        case 10:
          if (!resolver) {
            logger.throwError("a provider or signer is needed to resolve ENS names", Logger.errors.UNSUPPORTED_OPERATION, {
              operation: "resolveName"
            });
          }
          _context.next = 13;
          return resolver.resolveName(name);
        case 13:
          address = _context.sent;
          if (address == null) {
            logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
          }
          return _context.abrupt("return", address);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 8]]);
  }));
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function resolveAddresses(resolver, value, paramType) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!Array.isArray(paramType)) {
            _context2.next = 4;
            break;
          }
          _context2.next = 3;
          return Promise.all(paramType.map(function (paramType, index) {
            return resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
          }));
        case 3:
          return _context2.abrupt("return", _context2.sent);
        case 4:
          if (!(paramType.type === "address")) {
            _context2.next = 8;
            break;
          }
          _context2.next = 7;
          return resolveName(resolver, value);
        case 7:
          return _context2.abrupt("return", _context2.sent);
        case 8:
          if (!(paramType.type === "tuple")) {
            _context2.next = 12;
            break;
          }
          _context2.next = 11;
          return resolveAddresses(resolver, value, paramType.components);
        case 11:
          return _context2.abrupt("return", _context2.sent);
        case 12:
          if (!(paramType.baseType === "array")) {
            _context2.next = 18;
            break;
          }
          if (Array.isArray(value)) {
            _context2.next = 15;
            break;
          }
          return _context2.abrupt("return", Promise.reject(logger.makeError("invalid value for array", Logger.errors.INVALID_ARGUMENT, {
            argument: "value",
            value: value
          })));
        case 15:
          _context2.next = 17;
          return Promise.all(value.map(function (v) {
            return resolveAddresses(resolver, v, paramType.arrayChildren);
          }));
        case 17:
          return _context2.abrupt("return", _context2.sent);
        case 18:
          return _context2.abrupt("return", value);
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
}
function populateTransaction(contract, fragment, args) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _this = this;
    var overrides, resolved, data, tx, ro, intrinsic, bytes, i, roValue, leftovers;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          // If an extra argument is given, it is overrides
          overrides = {};
          if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            overrides = shallowCopy(args.pop());
          }
          // Make sure the parameter count matches
          logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
          // Populate "from" override (allow promises)
          if (contract.signer) {
            if (overrides.from) {
              // Contracts with a Signer are from the Signer's frame-of-reference;
              // but we allow overriding "from" if it matches the signer
              overrides.from = resolveProperties({
                override: resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
              }).then(function (check) {
                return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (getAddress(check.signer) !== check.override) {
                          logger.throwError("Contract with a Signer cannot override from", Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "overrides.from"
                          });
                        }
                        return _context3.abrupt("return", check.override);
                      case 2:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
              });
            } else {
              overrides.from = contract.signer.getAddress();
            }
          } else if (overrides.from) {
            overrides.from = resolveName(contract.provider, overrides.from);
            //} else {
            // Contracts without a signer can override "from", and if
            // unspecified the zero address is used
            //overrides.from = AddressZero;
          }
          // Wait for all dependencies to be resolved (prefer the signer over the provider)
          _context4.next = 6;
          return resolveProperties({
            args: resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: resolveProperties(overrides) || {}
          });
        case 6:
          resolved = _context4.sent;
          // The ABI coded transaction
          data = contract.interface.encodeFunctionData(fragment, resolved.args);
          tx = {
            data: data,
            to: resolved.address
          }; // Resolved Overrides
          ro = resolved.overrides; // Populate simple overrides
          if (ro.nonce != null) {
            tx.nonce = BigNumber.from(ro.nonce).toNumber();
          }
          if (ro.gasLimit != null) {
            tx.gasLimit = BigNumber.from(ro.gasLimit);
          }
          if (ro.gasPrice != null) {
            tx.gasPrice = BigNumber.from(ro.gasPrice);
          }
          if (ro.maxFeePerGas != null) {
            tx.maxFeePerGas = BigNumber.from(ro.maxFeePerGas);
          }
          if (ro.maxPriorityFeePerGas != null) {
            tx.maxPriorityFeePerGas = BigNumber.from(ro.maxPriorityFeePerGas);
          }
          if (ro.from != null) {
            tx.from = ro.from;
          }
          if (ro.type != null) {
            tx.type = ro.type;
          }
          if (ro.accessList != null) {
            tx.accessList = accessListify(ro.accessList);
          }
          // If there was no "gasLimit" override, but the ABI specifies a default, use it
          if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            intrinsic = 21000;
            bytes = arrayify(data);
            for (i = 0; i < bytes.length; i++) {
              intrinsic += 4;
              if (bytes[i]) {
                intrinsic += 64;
              }
            }
            tx.gasLimit = BigNumber.from(fragment.gas).add(intrinsic);
          }
          // Populate "value" override
          if (ro.value) {
            roValue = BigNumber.from(ro.value);
            if (!roValue.isZero() && !fragment.payable) {
              logger.throwError("non-payable method cannot override value", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
              });
            }
            tx.value = roValue;
          }
          if (ro.customData) {
            tx.customData = shallowCopy(ro.customData);
          }
          if (ro.ccipReadEnabled) {
            tx.ccipReadEnabled = !!ro.ccipReadEnabled;
          }
          // Remove the overrides
          delete overrides.nonce;
          delete overrides.gasLimit;
          delete overrides.gasPrice;
          delete overrides.from;
          delete overrides.value;
          delete overrides.type;
          delete overrides.accessList;
          delete overrides.maxFeePerGas;
          delete overrides.maxPriorityFeePerGas;
          delete overrides.customData;
          delete overrides.ccipReadEnabled;
          // Make sure there are no stray overrides, which may indicate a
          // typo or using an unsupported key.
          leftovers = Object.keys(overrides).filter(function (key) {
            return overrides[key] != null;
          });
          if (leftovers.length) {
            logger.throwError("cannot override ".concat(leftovers.map(function (l) {
              return JSON.stringify(l);
            }).join(",")), Logger.errors.UNSUPPORTED_OPERATION, {
              operation: "overrides",
              overrides: leftovers
            });
          }
          return _context4.abrupt("return", tx);
        case 36:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
}
function buildPopulate(contract, fragment) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return populateTransaction(contract, fragment, args);
  };
}
function buildEstimate(contract, fragment) {
  var signerOrProvider = contract.signer || contract.provider;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var tx;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!signerOrProvider) {
              logger.throwError("estimate require a provider or signer", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
              });
            }
            _context5.next = 3;
            return populateTransaction(contract, fragment, args);
          case 3:
            tx = _context5.sent;
            _context5.next = 6;
            return signerOrProvider.estimateGas(tx);
          case 6:
            return _context5.abrupt("return", _context5.sent);
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
  };
}
function addContractWait(contract, tx) {
  var wait = tx.wait.bind(tx);
  tx.wait = function (confirmations) {
    return wait(confirmations).then(function (receipt) {
      receipt.events = receipt.logs.map(function (log) {
        var event = deepCopy(log);
        var parsed = null;
        try {
          parsed = contract.interface.parseLog(log);
        } catch (e) {}
        // Successfully parsed the event log; include it
        if (parsed) {
          event.args = parsed.args;
          event.decode = function (data, topics) {
            return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
          };
          event.event = parsed.name;
          event.eventSignature = parsed.signature;
        }
        // Useful operations
        event.removeListener = function () {
          return contract.provider;
        };
        event.getBlock = function () {
          return contract.provider.getBlock(receipt.blockHash);
        };
        event.getTransaction = function () {
          return contract.provider.getTransaction(receipt.transactionHash);
        };
        event.getTransactionReceipt = function () {
          return Promise.resolve(receipt);
        };
        return event;
      });
      return receipt;
    });
  };
}
function buildCall(contract, fragment, collapseSimple) {
  var signerOrProvider = contract.signer || contract.provider;
  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var blockTag, overrides, tx, result, value;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            // Extract the "blockTag" override if present
            blockTag = undefined;
            if (!(args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object")) {
              _context6.next = 9;
              break;
            }
            overrides = shallowCopy(args.pop());
            if (!(overrides.blockTag != null)) {
              _context6.next = 7;
              break;
            }
            _context6.next = 6;
            return overrides.blockTag;
          case 6:
            blockTag = _context6.sent;
          case 7:
            delete overrides.blockTag;
            args.push(overrides);
          case 9:
            if (!(contract.deployTransaction != null)) {
              _context6.next = 12;
              break;
            }
            _context6.next = 12;
            return contract._deployed(blockTag);
          case 12:
            _context6.next = 14;
            return populateTransaction(contract, fragment, args);
          case 14:
            tx = _context6.sent;
            _context6.next = 17;
            return signerOrProvider.call(tx, blockTag);
          case 17:
            result = _context6.sent;
            _context6.prev = 18;
            value = contract.interface.decodeFunctionResult(fragment, result);
            if (collapseSimple && fragment.outputs.length === 1) {
              value = value[0];
            }
            return _context6.abrupt("return", value);
          case 24:
            _context6.prev = 24;
            _context6.t0 = _context6["catch"](18);
            if (_context6.t0.code === Logger.errors.CALL_EXCEPTION) {
              _context6.t0.address = contract.address;
              _context6.t0.args = args;
              _context6.t0.transaction = tx;
            }
            throw _context6.t0;
          case 28:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[18, 24]]);
    }));
  };
}
function buildSend(contract, fragment) {
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var txRequest, tx;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (!contract.signer) {
              logger.throwError("sending a transaction requires a signer", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
              });
            }
            // If the contract was just deployed, wait until it is mined
            if (!(contract.deployTransaction != null)) {
              _context7.next = 4;
              break;
            }
            _context7.next = 4;
            return contract._deployed();
          case 4:
            _context7.next = 6;
            return populateTransaction(contract, fragment, args);
          case 6:
            txRequest = _context7.sent;
            _context7.next = 9;
            return contract.signer.sendTransaction(txRequest);
          case 9:
            tx = _context7.sent;
            // Tweak the tx.wait so the receipt has extra properties
            addContractWait(contract, tx);
            return _context7.abrupt("return", tx);
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
  };
}
function buildDefault(contract, fragment, collapseSimple) {
  if (fragment.constant) {
    return buildCall(contract, fragment, collapseSimple);
  }
  return buildSend(contract, fragment);
}
function getEventTag(filter) {
  if (filter.address && (filter.topics == null || filter.topics.length === 0)) {
    return "*";
  }
  return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map(function (topic) {
    if (Array.isArray(topic)) {
      return topic.join("|");
    }
    return topic;
  }).join(":") : "");
}
var RunningEvent = /*#__PURE__*/function () {
  function RunningEvent(tag, filter) {
    _classCallCheck(this, RunningEvent);
    defineReadOnly(this, "tag", tag);
    defineReadOnly(this, "filter", filter);
    this._listeners = [];
  }
  _createClass(RunningEvent, [{
    key: "addListener",
    value: function addListener(listener, once) {
      this._listeners.push({
        listener: listener,
        once: once
      });
    }
  }, {
    key: "removeListener",
    value: function removeListener(listener) {
      var done = false;
      this._listeners = this._listeners.filter(function (item) {
        if (done || item.listener !== listener) {
          return true;
        }
        done = true;
        return false;
      });
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners() {
      this._listeners = [];
    }
  }, {
    key: "listeners",
    value: function listeners() {
      return this._listeners.map(function (i) {
        return i.listener;
      });
    }
  }, {
    key: "listenerCount",
    value: function listenerCount() {
      return this._listeners.length;
    }
  }, {
    key: "run",
    value: function run(args) {
      var _this2 = this;
      var listenerCount = this.listenerCount();
      this._listeners = this._listeners.filter(function (item) {
        var argsCopy = args.slice();
        // Call the callback in the next event loop
        setTimeout(function () {
          item.listener.apply(_this2, argsCopy);
        }, 0);
        // Reschedule it if it not "once"
        return !item.once;
      });
      return listenerCount;
    }
  }, {
    key: "prepareEvent",
    value: function prepareEvent(event) {} // Returns the array that will be applied to an emit
  }, {
    key: "getEmit",
    value: function getEmit(event) {
      return [event];
    }
  }]);
  return RunningEvent;
}();
var ErrorRunningEvent = /*#__PURE__*/function (_RunningEvent) {
  _inherits(ErrorRunningEvent, _RunningEvent);
  function ErrorRunningEvent() {
    _classCallCheck(this, ErrorRunningEvent);
    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorRunningEvent).call(this, "error", null));
  }
  return ErrorRunningEvent;
}(RunningEvent); // @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
var FragmentRunningEvent = /*#__PURE__*/function (_RunningEvent2) {
  _inherits(FragmentRunningEvent, _RunningEvent2);
  function FragmentRunningEvent(address, contractInterface, fragment, topics) {
    var _this3;
    _classCallCheck(this, FragmentRunningEvent);
    var filter = {
      address: address
    };
    var topic = contractInterface.getEventTopic(fragment);
    if (topics) {
      if (topic !== topics[0]) {
        logger.throwArgumentError("topic mismatch", "topics", topics);
      }
      filter.topics = topics.slice();
    } else {
      filter.topics = [topic];
    }
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(FragmentRunningEvent).call(this, getEventTag(filter), filter));
    defineReadOnly(_assertThisInitialized(_assertThisInitialized(_this3)), "address", address);
    defineReadOnly(_assertThisInitialized(_assertThisInitialized(_this3)), "interface", contractInterface);
    defineReadOnly(_assertThisInitialized(_assertThisInitialized(_this3)), "fragment", fragment);
    return _this3;
  }
  _createClass(FragmentRunningEvent, [{
    key: "prepareEvent",
    value: function prepareEvent(event) {
      var _this4 = this;
      _get(_getPrototypeOf(FragmentRunningEvent.prototype), "prepareEvent", this).call(this, event);
      event.event = this.fragment.name;
      event.eventSignature = this.fragment.format();
      event.decode = function (data, topics) {
        return _this4.interface.decodeEventLog(_this4.fragment, data, topics);
      };
      try {
        event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
      } catch (error) {
        event.args = null;
        event.decodeError = error;
      }
    }
  }, {
    key: "getEmit",
    value: function getEmit(event) {
      var errors = checkResultErrors(event.args);
      if (errors.length) {
        throw errors[0].error;
      }
      var args = (event.args || []).slice();
      args.push(event);
      return args;
    }
  }]);
  return FragmentRunningEvent;
}(RunningEvent); // A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
var WildcardRunningEvent = /*#__PURE__*/function (_RunningEvent3) {
  _inherits(WildcardRunningEvent, _RunningEvent3);
  function WildcardRunningEvent(address, contractInterface) {
    var _this5;
    _classCallCheck(this, WildcardRunningEvent);
    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(WildcardRunningEvent).call(this, "*", {
      address: address
    }));
    defineReadOnly(_assertThisInitialized(_assertThisInitialized(_this5)), "address", address);
    defineReadOnly(_assertThisInitialized(_assertThisInitialized(_this5)), "interface", contractInterface);
    return _this5;
  }
  _createClass(WildcardRunningEvent, [{
    key: "prepareEvent",
    value: function prepareEvent(event) {
      var _this6 = this;
      _get(_getPrototypeOf(WildcardRunningEvent.prototype), "prepareEvent", this).call(this, event);
      try {
        var parsed = this.interface.parseLog(event);
        event.event = parsed.name;
        event.eventSignature = parsed.signature;
        event.decode = function (data, topics) {
          return _this6.interface.decodeEventLog(parsed.eventFragment, data, topics);
        };
        event.args = parsed.args;
      } catch (error) {
        // No matching event
      }
    }
  }]);
  return WildcardRunningEvent;
}(RunningEvent);
export var BaseContract = /*#__PURE__*/function () {
  function BaseContract(addressOrName, contractInterface, signerOrProvider) {
    var _this7 = this;
    _classCallCheck(this, BaseContract);
    // @TODO: Maybe still check the addressOrName looks like a valid address or name?
    //address = getAddress(address);
    defineReadOnly(this, "interface", getStatic(this instanceof BaseContract ? this.constructor : void 0, "getInterface")(contractInterface));
    if (signerOrProvider == null) {
      defineReadOnly(this, "provider", null);
      defineReadOnly(this, "signer", null);
    } else if (Signer.isSigner(signerOrProvider)) {
      defineReadOnly(this, "provider", signerOrProvider.provider || null);
      defineReadOnly(this, "signer", signerOrProvider);
    } else if (Provider.isProvider(signerOrProvider)) {
      defineReadOnly(this, "provider", signerOrProvider);
      defineReadOnly(this, "signer", null);
    } else {
      logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
    }
    defineReadOnly(this, "callStatic", {});
    defineReadOnly(this, "estimateGas", {});
    defineReadOnly(this, "functions", {});
    defineReadOnly(this, "populateTransaction", {});
    defineReadOnly(this, "filters", {});
    {
      var uniqueFilters = {};
      Object.keys(this.interface.events).forEach(function (eventSignature) {
        var event = _this7.interface.events[eventSignature];
        defineReadOnly(_this7.filters, eventSignature, function () {
          for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
          }
          return {
            address: _this7.address,
            topics: _this7.interface.encodeFilterTopics(event, args)
          };
        });
        if (!uniqueFilters[event.name]) {
          uniqueFilters[event.name] = [];
        }
        uniqueFilters[event.name].push(eventSignature);
      });
      Object.keys(uniqueFilters).forEach(function (name) {
        var filters = uniqueFilters[name];
        if (filters.length === 1) {
          defineReadOnly(_this7.filters, name, _this7.filters[filters[0]]);
        } else {
          logger.warn("Duplicate definition of ".concat(name, " (").concat(filters.join(", "), ")"));
        }
      });
    }
    defineReadOnly(this, "_runningEvents", {});
    defineReadOnly(this, "_wrappedEmits", {});
    if (addressOrName == null) {
      logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
    }
    defineReadOnly(this, "address", addressOrName);
    if (this.provider) {
      defineReadOnly(this, "resolvedAddress", resolveName(this.provider, addressOrName));
    } else {
      try {
        defineReadOnly(this, "resolvedAddress", Promise.resolve(getAddress(addressOrName)));
      } catch (error) {
        // Without a provider, we cannot use ENS names
        logger.throwError("provider is required to use ENS name as contract address", Logger.errors.UNSUPPORTED_OPERATION, {
          operation: "new Contract"
        });
      }
    }
    // Swallow bad ENS names to prevent Unhandled Exceptions
    this.resolvedAddress.catch(function (e) {});
    var uniqueNames = {};
    var uniqueSignatures = {};
    Object.keys(this.interface.functions).forEach(function (signature) {
      var fragment = _this7.interface.functions[signature];
      // Check that the signature is unique; if not the ABI generation has
      // not been cleaned or may be incorrectly generated
      if (uniqueSignatures[signature]) {
        logger.warn("Duplicate ABI entry for ".concat(JSON.stringify(signature)));
        return;
      }
      uniqueSignatures[signature] = true;
      // Track unique names; we only expose bare named functions if they
      // are ambiguous
      {
        var name = fragment.name;
        if (!uniqueNames["%".concat(name)]) {
          uniqueNames["%".concat(name)] = [];
        }
        uniqueNames["%".concat(name)].push(signature);
      }
      if (_this7[signature] == null) {
        defineReadOnly(_this7, signature, buildDefault(_this7, fragment, true));
      }
      // We do not collapse simple calls on this bucket, which allows
      // frameworks to safely use this without introspection as well as
      // allows decoding error recovery.
      if (_this7.functions[signature] == null) {
        defineReadOnly(_this7.functions, signature, buildDefault(_this7, fragment, false));
      }
      if (_this7.callStatic[signature] == null) {
        defineReadOnly(_this7.callStatic, signature, buildCall(_this7, fragment, true));
      }
      if (_this7.populateTransaction[signature] == null) {
        defineReadOnly(_this7.populateTransaction, signature, buildPopulate(_this7, fragment));
      }
      if (_this7.estimateGas[signature] == null) {
        defineReadOnly(_this7.estimateGas, signature, buildEstimate(_this7, fragment));
      }
    });
    Object.keys(uniqueNames).forEach(function (name) {
      // Ambiguous names to not get attached as bare names
      var signatures = uniqueNames[name];
      if (signatures.length > 1) {
        return;
      }
      // Strip off the leading "%" used for prototype protection
      name = name.substring(1);
      var signature = signatures[0];
      // If overwriting a member property that is null, swallow the error
      try {
        if (_this7[name] == null) {
          defineReadOnly(_this7, name, _this7[signature]);
        }
      } catch (e) {}
      if (_this7.functions[name] == null) {
        defineReadOnly(_this7.functions, name, _this7.functions[signature]);
      }
      if (_this7.callStatic[name] == null) {
        defineReadOnly(_this7.callStatic, name, _this7.callStatic[signature]);
      }
      if (_this7.populateTransaction[name] == null) {
        defineReadOnly(_this7.populateTransaction, name, _this7.populateTransaction[signature]);
      }
      if (_this7.estimateGas[name] == null) {
        defineReadOnly(_this7.estimateGas, name, _this7.estimateGas[signature]);
      }
    });
  }
  _createClass(BaseContract, [{
    key: "deployed",
    // @TODO: Allow timeout?
    value: function deployed() {
      return this._deployed();
    }
  }, {
    key: "_deployed",
    value: function _deployed(blockTag) {
      var _this8 = this;
      if (!this._deployedPromise) {
        // If we were just deployed, we know the transaction we should occur in
        if (this.deployTransaction) {
          this._deployedPromise = this.deployTransaction.wait().then(function () {
            return _this8;
          });
        } else {
          // @TODO: Once we allow a timeout to be passed in, we will wait
          // up to that many blocks for getCode
          // Otherwise, poll for our code to be deployed
          this._deployedPromise = this.provider.getCode(this.address, blockTag).then(function (code) {
            if (code === "0x") {
              logger.throwError("contract not deployed", Logger.errors.UNSUPPORTED_OPERATION, {
                contractAddress: _this8.address,
                operation: "getDeployed"
              });
            }
            return _this8;
          });
        }
      }
      return this._deployedPromise;
    } // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
  }, {
    key: "fallback",
    value: function fallback(overrides) {
      var _this9 = this;
      if (!this.signer) {
        logger.throwError("sending a transactions require a signer", Logger.errors.UNSUPPORTED_OPERATION, {
          operation: "sendTransaction(fallback)"
        });
      }
      var tx = shallowCopy(overrides || {});
      ["from", "to"].forEach(function (key) {
        if (tx[key] == null) {
          return;
        }
        logger.throwError("cannot override " + key, Logger.errors.UNSUPPORTED_OPERATION, {
          operation: key
        });
      });
      tx.to = this.resolvedAddress;
      return this.deployed().then(function () {
        return _this9.signer.sendTransaction(tx);
      });
    } // Reconnect to a different signer or provider
  }, {
    key: "connect",
    value: function connect(signerOrProvider) {
      if (typeof signerOrProvider === "string") {
        signerOrProvider = new VoidSigner(signerOrProvider, this.provider);
      }
      var contract = new this.constructor(this.address, this.interface, signerOrProvider);
      if (this.deployTransaction) {
        defineReadOnly(contract, "deployTransaction", this.deployTransaction);
      }
      return contract;
    } // Re-attach to a different on-chain instance of this contract
  }, {
    key: "attach",
    value: function attach(addressOrName) {
      return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
  }, {
    key: "_normalizeRunningEvent",
    value: function _normalizeRunningEvent(runningEvent) {
      // Already have an instance of this event running; we can re-use it
      if (this._runningEvents[runningEvent.tag]) {
        return this._runningEvents[runningEvent.tag];
      }
      return runningEvent;
    }
  }, {
    key: "_getRunningEvent",
    value: function _getRunningEvent(eventName) {
      if (typeof eventName === "string") {
        // Listen for "error" events (if your contract has an error event, include
        // the full signature to bypass this special event keyword)
        if (eventName === "error") {
          return this._normalizeRunningEvent(new ErrorRunningEvent());
        }
        // Listen for any event that is registered
        if (eventName === "event") {
          return this._normalizeRunningEvent(new RunningEvent("event", null));
        }
        // Listen for any event
        if (eventName === "*") {
          return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
        }
        // Get the event Fragment (throws if ambiguous/unknown event)
        var fragment = this.interface.getEvent(eventName);
        return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fragment));
      }
      // We have topics to filter by...
      if (eventName.topics && eventName.topics.length > 0) {
        // Is it a known topichash? (throws if no matching topichash)
        try {
          var topic = eventName.topics[0];
          if (typeof topic !== "string") {
            throw new Error("invalid topic"); // @TODO: May happen for anonymous events
          }
          var _fragment = this.interface.getEvent(topic);
          return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, _fragment, eventName.topics));
        } catch (error) {}
        // Filter by the unknown topichash
        var filter = {
          address: this.address,
          topics: eventName.topics
        };
        return this._normalizeRunningEvent(new RunningEvent(getEventTag(filter), filter));
      }
      return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
    }
  }, {
    key: "_checkRunningEvents",
    value: function _checkRunningEvents(runningEvent) {
      if (runningEvent.listenerCount() === 0) {
        delete this._runningEvents[runningEvent.tag];
        // If we have a poller for this, remove it
        var emit = this._wrappedEmits[runningEvent.tag];
        if (emit && runningEvent.filter) {
          this.provider.off(runningEvent.filter, emit);
          delete this._wrappedEmits[runningEvent.tag];
        }
      }
    } // Subclasses can override this to gracefully recover
    // from parse errors if they wish
  }, {
    key: "_wrapEvent",
    value: function _wrapEvent(runningEvent, log, listener) {
      var _this10 = this;
      var event = deepCopy(log);
      event.removeListener = function () {
        if (!listener) {
          return;
        }
        runningEvent.removeListener(listener);
        _this10._checkRunningEvents(runningEvent);
      };
      event.getBlock = function () {
        return _this10.provider.getBlock(log.blockHash);
      };
      event.getTransaction = function () {
        return _this10.provider.getTransaction(log.transactionHash);
      };
      event.getTransactionReceipt = function () {
        return _this10.provider.getTransactionReceipt(log.transactionHash);
      };
      // This may throw if the topics and data mismatch the signature
      runningEvent.prepareEvent(event);
      return event;
    }
  }, {
    key: "_addEventListener",
    value: function _addEventListener(runningEvent, listener, once) {
      var _this11 = this;
      if (!this.provider) {
        logger.throwError("events require a provider or a signer with a provider", Logger.errors.UNSUPPORTED_OPERATION, {
          operation: "once"
        });
      }
      runningEvent.addListener(listener, once);
      // Track this running event and its listeners (may already be there; but no hard in updating)
      this._runningEvents[runningEvent.tag] = runningEvent;
      // If we are not polling the provider, start polling
      if (!this._wrappedEmits[runningEvent.tag]) {
        var wrappedEmit = function wrappedEmit(log) {
          var event = _this11._wrapEvent(runningEvent, log, listener);
          // Try to emit the result for the parameterized event...
          if (event.decodeError == null) {
            try {
              var args = runningEvent.getEmit(event);
              _this11.emit.apply(_this11, [runningEvent.filter].concat(_toConsumableArray(args)));
            } catch (error) {
              event.decodeError = error.error;
            }
          }
          // Always emit "event" for fragment-base events
          if (runningEvent.filter != null) {
            _this11.emit("event", event);
          }
          // Emit "error" if there was an error
          if (event.decodeError != null) {
            _this11.emit("error", event.decodeError, event);
          }
        };
        this._wrappedEmits[runningEvent.tag] = wrappedEmit;
        // Special events, like "error" do not have a filter
        if (runningEvent.filter != null) {
          this.provider.on(runningEvent.filter, wrappedEmit);
        }
      }
    }
  }, {
    key: "queryFilter",
    value: function queryFilter(event, fromBlockOrBlockhash, toBlock) {
      var _this12 = this;
      var runningEvent = this._getRunningEvent(event);
      var filter = shallowCopy(runningEvent.filter);
      if (typeof fromBlockOrBlockhash === "string" && isHexString(fromBlockOrBlockhash, 32)) {
        if (toBlock != null) {
          logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
        }
        filter.blockHash = fromBlockOrBlockhash;
      } else {
        filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
        filter.toBlock = toBlock != null ? toBlock : "latest";
      }
      return this.provider.getLogs(filter).then(function (logs) {
        return logs.map(function (log) {
          return _this12._wrapEvent(runningEvent, log, null);
        });
      });
    }
  }, {
    key: "on",
    value: function on(event, listener) {
      this._addEventListener(this._getRunningEvent(event), listener, false);
      return this;
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      this._addEventListener(this._getRunningEvent(event), listener, true);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(eventName) {
      if (!this.provider) {
        return false;
      }
      var runningEvent = this._getRunningEvent(eventName);
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      var result = runningEvent.run(args) > 0;
      // May have drained all the "once" events; check for living events
      this._checkRunningEvents(runningEvent);
      return result;
    }
  }, {
    key: "listenerCount",
    value: function listenerCount(eventName) {
      var _this13 = this;
      if (!this.provider) {
        return 0;
      }
      if (eventName == null) {
        return Object.keys(this._runningEvents).reduce(function (accum, key) {
          return accum + _this13._runningEvents[key].listenerCount();
        }, 0);
      }
      return this._getRunningEvent(eventName).listenerCount();
    }
  }, {
    key: "listeners",
    value: function listeners(eventName) {
      if (!this.provider) {
        return [];
      }
      if (eventName == null) {
        var result = [];
        for (var tag in this._runningEvents) {
          this._runningEvents[tag].listeners().forEach(function (listener) {
            result.push(listener);
          });
        }
        return result;
      }
      return this._getRunningEvent(eventName).listeners();
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(eventName) {
      if (!this.provider) {
        return this;
      }
      if (eventName == null) {
        for (var tag in this._runningEvents) {
          var _runningEvent = this._runningEvents[tag];
          _runningEvent.removeAllListeners();
          this._checkRunningEvents(_runningEvent);
        }
        return this;
      }
      // Delete any listeners
      var runningEvent = this._getRunningEvent(eventName);
      runningEvent.removeAllListeners();
      this._checkRunningEvents(runningEvent);
      return this;
    }
  }, {
    key: "off",
    value: function off(eventName, listener) {
      if (!this.provider) {
        return this;
      }
      var runningEvent = this._getRunningEvent(eventName);
      runningEvent.removeListener(listener);
      this._checkRunningEvents(runningEvent);
      return this;
    }
  }, {
    key: "removeListener",
    value: function removeListener(eventName, listener) {
      return this.off(eventName, listener);
    }
  }], [{
    key: "getContractAddress",
    value: function getContractAddress(transaction) {
      return _getContractAddress(transaction);
    }
  }, {
    key: "getInterface",
    value: function getInterface(contractInterface) {
      if (Interface.isInterface(contractInterface)) {
        return contractInterface;
      }
      return new Interface(contractInterface);
    }
  }, {
    key: "isIndexed",
    value: function isIndexed(value) {
      return Indexed.isIndexed(value);
    }
  }]);
  return BaseContract;
}();
export var Contract = /*#__PURE__*/function (_BaseContract) {
  _inherits(Contract, _BaseContract);
  function Contract() {
    _classCallCheck(this, Contract);
    return _possibleConstructorReturn(this, _getPrototypeOf(Contract).apply(this, arguments));
  }
  return Contract;
}(BaseContract);
export var ContractFactory = /*#__PURE__*/function () {
  function ContractFactory(contractInterface, bytecode, signer) {
    _classCallCheck(this, ContractFactory);
    var bytecodeHex = null;
    if (typeof bytecode === "string") {
      bytecodeHex = bytecode;
    } else if (isBytes(bytecode)) {
      bytecodeHex = hexlify(bytecode);
    } else if (bytecode && typeof bytecode.object === "string") {
      // Allow the bytecode object from the Solidity compiler
      bytecodeHex = bytecode.object;
    } else {
      // Crash in the next verification step
      bytecodeHex = "!";
    }
    // Make sure it is 0x prefixed
    if (bytecodeHex.substring(0, 2) !== "0x") {
      bytecodeHex = "0x" + bytecodeHex;
    }
    // Make sure the final result is valid bytecode
    if (!isHexString(bytecodeHex) || bytecodeHex.length % 2) {
      logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
    }
    // If we have a signer, make sure it is valid
    if (signer && !Signer.isSigner(signer)) {
      logger.throwArgumentError("invalid signer", "signer", signer);
    }
    defineReadOnly(this, "bytecode", bytecodeHex);
    defineReadOnly(this, "interface", getStatic(this instanceof ContractFactory ? this.constructor : void 0, "getInterface")(contractInterface));
    defineReadOnly(this, "signer", signer || null);
  }
  // @TODO: Future; rename to populateTransaction?
  _createClass(ContractFactory, [{
    key: "getDeployTransaction",
    value: function getDeployTransaction() {
      var tx = {};
      // If we have 1 additional argument, we allow transaction overrides
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
        tx = shallowCopy(args.pop());
        for (var key in tx) {
          if (!allowedTransactionKeys[key]) {
            throw new Error("unknown transaction override " + key);
          }
        }
      }
      // Do not allow these to be overridden in a deployment transaction
      ["data", "from", "to"].forEach(function (key) {
        if (tx[key] == null) {
          return;
        }
        logger.throwError("cannot override " + key, Logger.errors.UNSUPPORTED_OPERATION, {
          operation: key
        });
      });
      if (tx.value) {
        var value = BigNumber.from(tx.value);
        if (!value.isZero() && !this.interface.deploy.payable) {
          logger.throwError("non-payable constructor cannot override value", Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "overrides.value",
            value: tx.value
          });
        }
      }
      // Make sure the call matches the constructor signature
      logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
      // Set the data to the bytecode + the encoded constructor arguments
      tx.data = hexlify(concat([this.bytecode, this.interface.encodeDeploy(args)]));
      return tx;
    }
  }, {
    key: "deploy",
    value: function deploy() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var overrides, params, unsignedTx, tx, address, contract;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              overrides = {}; // If 1 extra parameter was passed in, it contains overrides
              if (args.length === this.interface.deploy.inputs.length + 1) {
                overrides = args.pop();
              }
              // Make sure the call matches the constructor signature
              logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
              // Resolve ENS names and promises in the arguments
              _context8.next = 5;
              return resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            case 5:
              params = _context8.sent;
              params.push(overrides);
              // Get the deployment transaction (with optional overrides)
              unsignedTx = this.getDeployTransaction.apply(this, _toConsumableArray(params)); // Send the deployment transaction
              _context8.next = 10;
              return this.signer.sendTransaction(unsignedTx);
            case 10:
              tx = _context8.sent;
              address = getStatic(this.constructor, "getContractAddress")(tx);
              contract = getStatic(this.constructor, "getContract")(address, this.interface, this.signer); // Add the modified wait that wraps events
              addContractWait(contract, tx);
              defineReadOnly(contract, "deployTransaction", tx);
              return _context8.abrupt("return", contract);
            case 16:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return this.constructor.getContract(address, this.interface, this.signer);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return new this.constructor(this.interface, this.bytecode, signer);
    }
  }], [{
    key: "fromSolidity",
    value: function fromSolidity(compilerOutput, signer) {
      if (compilerOutput == null) {
        logger.throwError("missing compiler output", Logger.errors.MISSING_ARGUMENT, {
          argument: "compilerOutput"
        });
      }
      if (typeof compilerOutput === "string") {
        compilerOutput = JSON.parse(compilerOutput);
      }
      var abi = compilerOutput.abi;
      var bytecode = null;
      if (compilerOutput.bytecode) {
        bytecode = compilerOutput.bytecode;
      } else if (compilerOutput.evm && compilerOutput.evm.bytecode) {
        bytecode = compilerOutput.evm.bytecode;
      }
      return new this(abi, bytecode, signer);
    }
  }, {
    key: "getInterface",
    value: function getInterface(contractInterface) {
      return Contract.getInterface(contractInterface);
    }
  }, {
    key: "getContractAddress",
    value: function getContractAddress(tx) {
      return _getContractAddress(tx);
    }
  }, {
    key: "getContract",
    value: function getContract(address, contractInterface, signer) {
      return new Contract(address, contractInterface, signer);
    }
  }]);
  return ContractFactory;
}();